import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useAuth } from '../context/auth';
import { useMobileDevice } from '../context/util';

export const MakeRouteWithSubRoutes = (route) => {
  const { isAuthenticated } = useAuth();
  const { isMobile } = useMobileDevice();

  const renderComponent = (props) => {
    if (isMobile && route.mobileComponent) {
      const { mobileComponent: Component } = route;
      return <Component {...props} routes={route.routes} />;
    }
    return <route.component {...props} routes={route.routes} />;
  };

  return (
    <Route
      className="component-body"
      path={route.path}
      render={(props) =>
        isAuthenticated || !route.isPrivate ? renderComponent(props) : <Redirect to="/portal/login" />
      }
    />
  );
};
